<template>
  <div class="nav-main-box">
    <van-nav-bar fixed title="订单"/>
    <!-- 注意事项tab切换   -->
    <div class="v_mainBox">
      <van-tabs v-model="active" swipeable sticky @change="onVanTab">
        <!--    标题栏    -->
        <van-tab c v-for="(item,index) in tabs_title" :key="index" :title="item">
          <!--    列表1      -->
          <div class="list-box">
            <div v-if="index ===0 ">
              <div class="box" v-for="item in list" :key="item.id" @click="goOrderInfor(item)">
                <p class="nav-line"><span class="left">{{
                    item &&
                    item.carInspectionVehicleLicenseEntity &&
                    item.carInspectionVehicleLicenseEntity.plateNo
                  }}</span><span class="right">{{
                    item.orderStatus
                  }}</span>
                </p>
                <div class="van-cen">
                  <p><span>姓名</span><span>{{ item.name }}</span></p>
                  <p><span>电话</span><span>{{ item.tel }}</span></p>
                  <p><span>预约编号</span><span>{{ item.orderId }}</span></p>
                  <p><span>预约类型</span><span>{{ item.reservationType }}</span></p>
                  <p><span>车检站</span><span>{{ item.carInspectionStation }}</span></p>
                </div>
                <div class="van-botm">
									<span class="left">
                    <span class="van-time"><i class="van-icon van-icon-clock"></i></span>
                    <span>{{ item.appointment }}</span>
                  </span>
                  <span class="right">￥{{ item.totalCost }}</span>
                </div>
              </div>
              <van-button v-if="isMoreShow" :loading="loading" type="primary" block loading-text="加载中..."
                          @click="onLoad">
                加载更多
              </van-button>
              <van-divider v-if="!isMoreShow">没有更多了</van-divider>
            </div>
            <div v-if="index ===1 ">
              <div class="box" v-for="item in list" :key="item.id" @click="goOrderInfor(item)">
                <p class="nav-line"><span class="left">{{
                    item &&
                    item.carInspectionVehicleLicenseEntity &&
                    item.carInspectionVehicleLicenseEntity.plateNo
                  }}</span><span class="right">{{
                    item.orderStatus
                  }}</span>
                </p>
                <div class="van-cen">
                  <p><span>姓名</span><span>{{ item.name }}</span></p>
                  <p><span>电话</span><span>{{ item.tel }}</span></p>
                  <p><span>预约编号</span><span>{{ item.orderId }}</span></p>
                  <p><span>预约类型</span><span>{{ item.reservationType }}</span></p>
                  <p><span>车检站</span><span>{{ item.carInspectionStation }}</span></p>
                </div>
                <div class="van-botm">
									<span class="left">
                    <span class="van-time"><i class="van-icon van-icon-clock"></i></span>
                    <span>{{ item.appointment }}</span>
                  </span>
                  <span class="right">￥{{ item.totalCost }}</span>
                </div>
              </div>
              <van-button v-if="isMoreShow" :loading="loading" type="primary" block loading-text="加载中..."
                          @click="onLoad">
                加载更多
              </van-button>
              <van-divider v-if="!isMoreShow">没有更多了</van-divider>
            </div>
            <div v-if="index ===2 ">
              <div class="box" v-for="item in list" :key="item.id" @click="goOrderInfor(item)">
                <p class="nav-line"><span class="left">{{
                    item &&
                    item.carInspectionVehicleLicenseEntity &&
                    item.carInspectionVehicleLicenseEntity.plateNo
                  }}</span><span class="right">{{
                    item.orderStatus
                  }}</span>
                </p>
                <div class="van-cen">
                  <p><span>姓名</span><span>{{ item.name }}</span></p>
                  <p><span>电话</span><span>{{ item.tel }}</span></p>
                  <p><span>订单号</span><span>{{ item.orderId }}</span></p>
                  <p><span>预约类型</span><span>{{ item.reservationType }}</span></p>
                  <p><span>车检站</span><span>{{ item.carInspectionStation }}</span></p>
                </div>
                <div class="van-botm">
									<span class="left">
                    <span class="van-time"><i class="van-icon van-icon-clock"></i></span>
                    <span>{{ item.appointment }}</span>
                  </span>
                  <span class="right">￥{{ item.totalCost }}</span>
                </div>
              </div>
              <van-button v-if="isMoreShow" :loading="loading" type="primary" block loading-text="加载中..."
                          @click="onLoad">
                加载更多
              </van-button>
              <van-divider v-if="!isMoreShow">没有更多了</van-divider>
            </div>
            <div v-if="index ===3 ">
              <div class="box" v-for="item in list" :key="item.id" @click="goOrderInfor(item)">
                <p class="nav-line"><span class="left">{{
                    item &&
                    item.carInspectionVehicleLicenseEntity &&
                    item.carInspectionVehicleLicenseEntity.plateNo
                  }}</span><span class="right">{{
                    item.orderStatus
                  }}</span>
                </p>
                <div class="van-cen">
                  <p><span>姓名</span><span>{{ item.name }}</span></p>
                  <p><span>电话</span><span>{{ item.tel }}</span></p>
                  <p><span>订单号</span><span>{{ item.orderId }}</span></p>
                  <p><span>预约类型</span><span>{{ item.reservationType }}</span></p>
                  <p><span>车检站</span><span>{{ item.carInspectionStation }}</span></p>
                </div>
                <div class="van-botm">
									<span class="left">
                    <span class="van-time"><i class="van-icon van-icon-clock"></i></span>
                    <span>{{ item.appointment }}</span>
                  </span>
                  <span class="right">￥{{ item.totalCost }}</span>
                </div>
              </div>
              <van-button v-if="isMoreShow" :loading="loading" type="primary" block loading-text="加载中..."
                          @click="onLoad">
                加载更多
              </van-button>
              <van-divider v-if="!isMoreShow">没有更多了</van-divider>
            </div>
            <div v-if="index ===4 ">
              <div class="box" v-for="(item,index) in comments_list" :key="index">
                <div class="van-pl">
                  <div class="van-plTitle">
                    <p class="p_one">
                      <span class="span1">{{ item.carInspectionComment.plateNo }}</span>
                      <span class="span2">{{ item.carInspectionComment.reservationType }}</span>
                    </p>
                    <p class="van-cData">{{ item.carInspectionComment.createTime }}</p>
                  </div>
                  <div class="van-inforT">
                    <p>{{ item.carInspectionComment.content }}</p>
                  </div>
                  <div class="van-inforImg mui-content-padded">
                    <span
                        v-for="item in (item.carInspectionComment.imgs === null ? 0 :item.carInspectionComment.imgs.split(','))"
                        :key="item.images" :title="item">
                     <van-image height="90px" fit="cover" :src="baseApi + '/file/' + item" @click="onPreviewImg(item)"/>
                    </span>
                  </div>
                  <div class="van-kf" v-for="mm in item.reply" :key="mm.id">
                    <p class="van-titleH">{{ mm.nickName }}回复：</p>
                    <p class="van-hf">{{ mm.content }}</p>
                  </div>
                </div>
              </div>
              <van-button v-if="isMoreShow" :loading="loading" type="primary" block loading-text="加载中..."
                          @click="onLoad1">
                加载更多
              </van-button>
              <van-divider v-if="!isMoreShow">没有更多了</van-divider>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <van-image-preview v-model="show" :images="images"></van-image-preview>
  </div>
</template>

<script>
import carInspectionOrder from "@/api/carInspectionOrder";
import carInspectionComment from "@/api/carInspectionComment";
import {baseApi} from "@/utils/auth";

export default {
  name: "index",
  data() {
    return {
      active: 0,
      tabs_title: ['全部', '已确认', '待确认', '已取消', '评价'],
      list: [],
      comments_list: [],
      show: false,
      index: 0,
      images: [],
      orderStatus: null,
      current: 1,
      size: 10,
      total: 0,
      loading: false,
      isMoreShow: true,
      baseApi: baseApi()
    }
  },
  created() {
    this.getOrderList()
  },
  methods: {
    getOrderList() {
      this.loading = true;
      const toast = this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      carInspectionOrder.getByPage({
        'orderStatus': this.orderStatus,
        'current': this.current,
        'size': this.size
      }).then(res => {
        // this.list = res.records
        this.current = res.current
        this.size = res.size
        this.total = res.total
        this.list.push.apply(this.list, res.records)
        this.loading = false;
        if (this.list.length >= this.total) {
          this.isMoreShow = false
        } else {
          this.isMoreShow = true
        }
        toast.clear()
      }).catch(err => {
        this.loading = false;
        // eslint-disable-next-line no-console
        console.log(err.data.message)
        toast.clear()
      })
    },
    getCommentList() {
      const toast = this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      this.loading = true;
      carInspectionComment.queryPageByUserId({
        'current': this.current,
        'size': this.size
      }).then(res => {
        this.current = res.current
        this.size = res.size
        this.total = res.total
        this.comments_list.push.apply(this.comments_list, res.records)
        this.loading = false;
        if (this.comments_list.length >= this.total) {
          this.isMoreShow = false
        } else {
          this.isMoreShow = true
        }
        toast.clear()
      }).catch(err => {
        this.loading = false;
        // eslint-disable-next-line no-console
        console.log(err.data.message)
        toast.clear()
      })
    },
    onVanTab(name) {
      this.list.length = 0
      this.comments_list.length = 0
      this.current = 1
      this.total = 0
      switch (name) {
        case 0:
          this.orderStatus = null
          this.getOrderList()
          break
        case 1:
          this.orderStatus = '已确认'
          this.getOrderList()
          break
        case 2:
          this.orderStatus = '已支付'
          this.getOrderList()
          break
        case 3:
          this.orderStatus = '已取消'
          this.getOrderList()
          break
        case 4:
          this.getCommentList()
          break
      }
    },
    goOrderInfor(item) {
      this.$router.push({
        path: '/orderInfor',
        query: {id: item.id}
      })
    },
    /**
     * 图片预览
     */
    onPreviewImg(imgs) {
      this.images.length = 0
      this.images.push(baseApi() + '/file/' + imgs)
      this.show = true
    },
    /**
     * 加载更多
     */
    onLoad() {
      this.current = this.current + 1
      this.getOrderList()
    },
    onLoad1() {
      this.current = this.current + 1
      this.getCommentList()
    },
  }
}
</script>
<style scoped>
.v_mainBox {
  padding-top: 50px
}

.van-tabs--line .van-tabs__wrap {
  position: fixed;
  z-index: 1;
}

.list-box {
  width: 100%;
  height: auto;
  display: block;
  overflow: hidden;
  margin-bottom: 60px;
}

.box {
  border: 1px solid #eee;
  border-radius: 5px;
  overflow: hidden;
  margin: 10px 2px;
  padding: 0 15px;
  box-shadow: 1px 2px 0px #eee;
}

.nav-line {
  width: 100%;
  height: 45px;
  line-height: 45px;
  border-bottom: 1px solid #eee;
}

.nav-line .left {
  float: left;
  font-size: 15px;
  font-weight: bold;
}

.nav-line .right {
  float: right;
  font-size: 13px;
  color: #3778d0;
}

.van-cen {
  width: 100%;
  height: auto;
  border-bottom: 1px solid #eee;
}

.van-cen p {
  width: 100%;
  height: 30px;
  line-height: 30px;
  color: #666;
  font-size: 13px;
  overflow: hidden;

}

.van-cen p span {
  width: 30%;
  display: inline-block;
  float: left;
  overflow: hidden;


}

.van-cen p span:nth-child(2) {
  text-align: right;
  width: 70%;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.van-botm {
  width: 100%;
  height: 45px;
  line-height: 45px;
  overflow: hidden;
}

.van-botm .left {
  width: 50%;
  float: left;
  font-size: 12px;
  color: #999;
}

.van-botm .left .van-time {
  display: inline-block;
  width: 10%;
  padding-right: 3%;
}

.van-botm .left .van-time .van-icon {
  color: #3778d0;
}

.van-botm .right {
  width: 50%;
  float: right;
  text-align: right;
  font-size: 16px;
  color: #3778d0;
}

.van-button--primary {
  background-color: #fff !important;
  background-color: #fff !important;
  color: #666 !important;
  margin-top: 50% !important
}
</style>
